export default "__VITE_ASSET__5040b410__"